module.exports = __webpack_public_path__ + "static/media/iphone-mockup-sec1-1.0c4e0726.png";